<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/subscriptionModule">Subscription Module</a></li>
      <li class="breadcrumb-item active" aria-current="page">Subscription Feature</li>
    </ol>
  </nav>
</div>

<div class="container mt-1 themeTblReso">
  <div class="assignFilterBar">
    <div class="filterItem" *ngIf="companyID==0">
      <select name="company" class="form-control formstyle" [ngModel]="selectedCompany" (ngModelChange)="onCompanyChange($event)">
        <option value="">Select Company Name</option>
        <ng-container *ngFor="let userObj of getCompanyobj">
          <option *ngIf="userObj.dbstatus == true" value={{userObj.customer_id}}>
            {{ userObj.customer_company_name }}
          </option>
        </ng-container>
      </select>
    </div>
    <div class="filterItem filterSearch">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text cyan lighten-2" id="basic-text1"><i class="fa fa-search text-white"
              aria-hidden="true"></i></span>
        </div>
        <input class="form-control" type="text" placeholder="Search" aria-label="Search" #searchText/>
      </div>
    </div>
    <div class="filterAction">
      <input type="button" value="Reset" class="custbtn-outline" (click)="resetFilters()" />
      <input type="button" value="Add New" class="custbtn" routerLink="/corporate/add-subscription-feature" />
    </div>
  </div>
  <div class="tblPrt">
    <table class="mt-1 bdrStCustom" width="100%" cellpadding="0" cellspacing="0">
      <tr>
        <th (click)="setOrder('feature_name')" style="cursor: pointer">Feature Name <i class="fa fa-sort text-black" aria-hidden="true"></i></th>
        <th>Slug</th>
        <th>Type</th>
        <th (click)="setOrder('feature_desc')" style="cursor: pointer">Description <i class="fa fa-sort text-black" aria-hidden="true"></i></th>
        <th (click)="setOrder('order_no')" style="cursor: pointer">Order No <i class="fa fa-sort text-black" aria-hidden="true"></i></th>
        <th (click)="setOrder('created_dt')" style="cursor: pointer">
          Created On <i class="fa fa-sort text-black" aria-hidden="true"></i>
        </th>
        <th>Actions</th>
      </tr>
      <tr *ngFor="let category of categoryObj">
        <td>{{category?.feature_name}}</td>
        <td>{{category?.feature_slug}}</td>
        <td>{{category?.feature_type}}</td>
        <td class="descCell">{{category?.feature_desc}}</td>
        <td>{{category?.order_no}}</td>
        <td>{{category?.created_dt | date: "mediumDate"}}</td>
        <td>
          <div class="actBtn">
            <i *ngIf='isEdit' class="fa fa-edit mr-1 linkForce" (click)="editPost(category.id)"></i>
            <i *ngIf='isEdit' class="fa fa-trash mr-1 linkForce"
              (click)="delCategory($event, category.id)"></i>
            <mat-slide-toggle *ngIf='isEdit' class="my-slider" [checked]="category.isactive"
              (click)="updateStatus($event, category.id, category.isactive)">
            </mat-slide-toggle>
          </div>
        </td>
      </tr>
    </table>
    <div *ngIf="webCatTotal == 0" style="text-align: center">
      <p>No Result Available</p>
    </div>
    <div class="row mt-2 align-items-center" *ngIf="webCatTotal > 0">
      <div class="col-md-3">
        <select class="form-control formstyle" [ngModel]="slCatLimit" (ngModelChange)="onLimitChange($event)">
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
        </select>
      </div>
      <div class="col-md-9 text-center difPagination" *ngIf="webCatTotal > slCatLimit">
        <ngb-pagination [collectionSize]="webCatTotal" [(page)]="slCatPage" [pageSize]="slCatLimit" [maxSize]="2" [rotate]="true" (pageChange)="getFeatureList(slCatPage=$event)" aria-label="Custom pagination">
          <ng-template ngbPaginationPrevious>Prev</ng-template>
          <ng-template ngbPaginationNext>Next</ng-template>
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>
